import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "CircleRemove.svg",
  "use": "CircleRemove.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"CircleRemove.svg\"><path d=\"M32.01,56.0209a24,24,0,1,1,24-24A24,24,0,0,1,32.01,56.0209Zm0-44.0009A20.0009,20.0009,0,1,0,52.0114,32.0209,20.0009,20.0009,0,0,0,32.01,12.02Zm-15,20.0009a2,2,0,0,1,2-2h26a2,2,0,0,1,0,4h-26A2,2,0,0,1,17.01,32.0209Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol